<template>
  <div
   :class="{'card-padding':padding==true, 'card-border':border==true, 'shadow':shadow==true}"
   v-click-outside-el="hide"
   @click="onClickCard"
   :id="cardId"
   >
    <slot></slot>
  </div>
</template>

<script>
import * as JSFunctions from "../Functions/Functions";
import SCardSection from "./SCardSection";

export default {
  name: "SCard",
  data(){
    return{
      cardId:"",
    };
  },
  props: {
    padding: { type: Boolean, default: false},
    border: {type: Boolean, default: false},
    shadow: {type: Boolean, default: false}
  },
  methods: {
    getClasses() {
      let cssClass = "card";
      if (this.padding) {
        cssClass = cssClass + " card-padding";
      }
      if (this.border) {
        // console.log(this.border);
        cssClass = cssClass + " card-border";
      }
      return cssClass;
    },

    hide: function() {
      var cardElement = document.getElementById(this.cardId);
      cardElement.style.boxShadow = "none";
    },

    onClickCard(){
      var cardElement = document.getElementById(this.cardId);
      if(this.shadow === true){
        cardElement.style.boxShadow = "0 0 20px var(--very-light-pink)";
      }
      this.$emit("card-click",true);
    }
  },
  created(){
    this.cardId = "Scard" + JSFunctions.uuid();
  },
};
</script>

<style >
.card {
  height: auto;
}
.shadow{
  height: auto;
  box-shadow: 0 0 20px var(--very-light-pink) !important;
  -webkit-box-shadow: 0 0 20px var(--very-light-pink) !important;
}
.shadow:hover{
  box-shadow: 0 !important;
  -webkit-box-shadow: 0 !important;
}
.card-padding {
  padding: 24px;
}
.card-border{
  border: solid 1px var(--very-light-pink);
}
</style>